import { handleActions } from "redux-actions";
import * as Immutable from "immutable";
import { setSelectedLocation } from "../index";
import {
  fetchLocationReceived,
  fetchLocationsReceived,
  updateLocationReceived,
  updateLocationRequested,
  updateLocationFailed,
} from "../index";
import {userLogoutReceived} from "../../../security";

const initialState: Immutable.Map<string, any> = Immutable.fromJS({
  selectedLocationId: null,
  selectedLocation: {},
  locations: [],
  isFetchingData: false,
  error: ''
});


const locationReducer = handleActions(
  {
    [updateLocationRequested](state, action) {
      return state.set("isFetchingData", true);
    },
    [updateLocationReceived](state, action) {
      return state.set("isFetchingData", false);
    },
    [updateLocationFailed](state, action) {
      return state.set("error", action.payload)
    },
    [setSelectedLocation](state, action) {
      return state.set("selectedLocationId", action.payload);
    },
    [fetchLocationReceived](state, action) {
      return state
        .set("isFetchingData", false)
        .update("locations", locations => {
          console.log(locations);
          console.log(action.payload);
          const index = locations.findIndex(account => account.get("locationId") === action.payload.locationId)
          if (index >= 0) {
            return locations.set(index, Immutable.fromJS(action.payload))
          } else {
            return locations.push(Immutable.fromJS(action.payload))
          }
        });
    },
    [fetchLocationsReceived](state, action) {
      return state.set("locations", Immutable.fromJS(action.payload));
    },
    [userLogoutReceived](state, action) {
      return initialState
    }
  },
  initialState
);

export { locationReducer }
export default locationReducer



// WEBPACK FOOTER //
// ./src/features/location/store/locationReducer.js